import Api from '../global/api';

export function occupanciesLoad () {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'OCCUPANCIES_LOAD',
            status: 'LOADING',
            payload: null
        })

        let active_profile = await Api.getLocal('_bvap');
        if(active_profile !== null){
            Api.req(`/occupancies/${active_profile}`, 'GET').then(
                res => {

                    Api.setLocal('occupancies', res.result);

                    dispatch({
                        type: 'OCCUPANCIES_LOAD',
                        status: 'OK',
                        payload: res.result
                    })
                },
                err => {
                    // Login error
                    dispatch({
                        type: 'OCCUPANCIES_LOAD',
                        status: 'error',
                        payload: typeof err.msg === 'string' ? err.msg : 'Sorry we were unable to load your occupancies'
                    })
                }
            )
        }

    }
}

export function occupancyAdd (payload) {
    return dispatch => {

        // Loading
        dispatch({
            type: 'OCCUPANCY_ADD',
            status: 'OK',
            payload: payload
        })

        return 'success';

    }
}

export function occupancyUpdate (payload) {
    return async dispatch => {

        // Loading
        dispatch({
            type: 'OCCUPANCY_UPDATE',
            status: 'OK',
            payload: payload
        })
        
    }
}